

if (!customElements.get('component-slide-item')) {
    customElements.define('component-slide-item',
        class ComponentSlideItem extends HTMLElement {
            constructor() {
                super();
                this._hydrated = false;
                this._onIntersect = this._onIntersect.bind(this);
            }

            connectedCallback() {
                this._templates = Array.from(this.querySelectorAll(':scope > template'));
                if (!this._templates.length) return;

                if (!('IntersectionObserver' in window)) {
                    this._hydrate();
                    return;
                }

                this._observer = new IntersectionObserver(this._onIntersect, {
                    root: null,
                    rootMargin: '200px 0px 0px 0px',
                    threshold: 0
                });

                this._observer.observe(this);
            }

            disconnectedCallback() {
                if (this._observer) {
                    this._observer.disconnect();
                    this._observer = null;
                }
            }

            _onIntersect(entries) {
                for (const entry of entries) {
                    if (entry.isIntersecting && !this._hydrated) {
                        this._hydrate();
                    }
                }
            }

            _hydrate() {
                if (this._hydrated) return;
                this._hydrated = true;

                if (this._observer) {
                    this._observer.disconnect();
                    this._observer = null;
                }

                this._templates.forEach((tpl) => {
                    const frag = tpl.content.cloneNode(true);
                    tpl.replaceWith(frag);
                });

                this.dispatchEvent(new CustomEvent('slideshydrated', {
                    bubbles: true,
                    detail: { target: this }
                }));
            }
        }

    );
}
